import React, { Component } from 'react'
import { render } from 'react-dom'
import Search from './search';
import Calendar from './calendar';
import Guests from './guests';


class BookNowForm extends Component {

  constructor(props) {
    super(props);
    this.state = {
      bookNowUrl : '',
      finalurl: '',
      calendarUrl: '',
      guestUrl: '&adult=2&child=0&childages=0&rooms=1',
      text_cosi: <div className="cosi_text">{Drupal.t("WHAT'S")} <span>{Drupal.t("THE DATE ?")}</span></div>,
      ppt_name: [],
      ppt_fast: [],
      hide_flexi: true,
      isHotel: true
    }
  }

  setBookNowUrl = (url) => {
    this.setState({
      bookNowUrl: url
    })
  }

  setFlexi = (data) => {
    var name = data.fastbooking_property_id;
    if (drupalSettings.is_sabre) {
      name = data.sabre_property_id;
    }

    this.setState({
      ppt_name: name,
      ppt_fast: data.ppt_fast
    })
  }

  setCalendarData = (payload) => {
    if (drupalSettings.is_sabre) {
      var calendar_url = '&arrive=' + payload.fromyear + '-' + payload.frommonth + '-' + payload.fromday + '&depart=' + payload.toyear + '-' + payload.tomonth + '-' + payload.dayto
    }
    else {
      var calendar_url = '&frommonth=' + payload.frommonth + '&fromday=' + payload.fromday + '&fromyear=' + payload.fromyear + '&nbdays=' + payload.nbdays + '&iR_accesskey=' + this.getCookie('irewards_accesskey') + '&iR_member=' + this.getCookie('irewards_member_id')
    }
    this.setState ({
      calendarUrl : calendar_url
    },() => {
      }
    )
  }

  setGuestData = (payload) => {
    if (drupalSettings.is_sabre) {
      var guest_url = '&adult=' + payload.adulteresa + '&child=' + payload.enfantresa + '&childages=' + payload.childrenAges + '&rooms=' + payload.roomCount
    }
    else {
      var guest_url = '&adulteresa=' + payload.adulteresa + '&enfantresa=' + payload.enfantresa + '&childrenAges1=' + payload.childrenAges
    }
    this.setState ({
      guestUrl: guest_url
    })
  }

  getCookie(key) {
    let b = document.cookie.match('(^|;)\\s*' + key + '\\s*=\\s*([^;]+)');
    return b ? b.pop() : '';
  }

  removeParamsByKey(url, keysToRemove) {
    if(url){
      let urlObj = new URL(url);
      let params = new URLSearchParams(urlObj.search);
      keysToRemove.forEach(key => {
          params.delete(key);
      });
  
      urlObj.search = params.toString();
      return urlObj.toString();
    } else{
      return ""
    }
  }

  setFinalUrl = () => {
    this.state.isHotel = true;
    if(drupalSettings.is_sabre && ((typeof this.state.ppt_name !== 'string' && this.state.ppt_name.length === 0) || this.state.ppt_name === '')) {
      this.state.isHotel = false;
    }

    var checker;
    var url_path;
    if(typeof(drupalSettings.property_page) != "undefined") {
      checker = drupalSettings.property_page.ppty_id;
      if (drupalSettings.is_sabre) {
        var properties_data = JSON.parse(drupalSettings.centara_sabre.booknow_property_data);
      }
      else {
        var properties_data = JSON.parse(drupalSettings.centara_fastbooking.booknow_property_data);
      }
      properties_data.map(function(er, i) {
        Object.keys(er).forEach(function(key) {
          if(er[key] === checker) {
            url_path = er.book_now_url;
          }
        });
      })
      if (url_path && this.state.calendarUrl && this.state.guestUrl && this.state.isHotel) {
        this.setState ({
          finalurl: url_path + this.state.calendarUrl + this.state.guestUrl
        },() => {
          var currency_code = this.getCookie('currency_code');
          if (currency_code == '') {
            currency_code = 'THB';
          }
          var final_url_arr = this.state.finalurl.split('?')[1].replace(/&amp;/g, '&').split('&');
          final_url_arr.forEach(function(item, index) {
            if (item.indexOf('currency=') !== -1) {
              if (item !== "currency=" + currency_code) {
                final_url_arr[index] = "currency=" + currency_code;
              }
            }
          });
          this.state.finalurl = this.state.finalurl.split('?')[0] + '?' + final_url_arr.sort().join('&');
          const encoded = window.encodeURIComponent(this.state.finalurl);
          let gl = _GA4CrossDomain._gl;
          let url = `/sabre-booking?url=${encoded}&_gl=${gl}`;
          window.open(url, '_blank');
        })
      }
    }
    else {
      let cleanedUrl = this.removeParamsByKey(this.state.bookNowUrl, ["arrive", "depart"]);
      this.setState ({
        finalurl: cleanedUrl + this.state.calendarUrl + this.state.guestUrl
      },() => {
        if (drupalSettings.is_sabre) {
          if (this.state.bookNowUrl && this.state.bookNowUrl.split('?')[1]) {
            var bookNowUrlArr = this.state.bookNowUrl.split('?')[1].split('&');
            var currency_code = this.getCookie('currency_code');
            if (currency_code == '') {
              currency_code = 'THB';
            }
            if (this.state.bookNowUrl.indexOf('currency') === -1) {
              bookNowUrlArr.push("currency=" + currency_code);
            }
            this.state.bookNowUrl = this.state.bookNowUrl.split('?')[0] + '?' + bookNowUrlArr.sort().join('&');
            var final_url_arr = this.state.finalurl.split('?')[1].replace(/&amp;/g, '&').split('&');
            final_url_arr.forEach(function(item, index) {
              if (item.indexOf('currency=') !== -1) {
                if (item !== "currency=" + currency_code) {
                  final_url_arr[index] = "currency=" + currency_code;
                }
              }
            });

            this.state.finalurl = this.state.finalurl.split('?')[0] + '?' + final_url_arr.sort().join('&');
            this.state.bookNowUrl = this.state.finalurl;
          }
        }
        if (this.state.isHotel) {
          const encoded = window.encodeURIComponent(this.state.finalurl);
          let gl = _GA4CrossDomain._gl;
          let url = `/sabre-booking?url=${encoded}&_gl=${gl}`;
          window.open(url, '_blank');
        }
      })
    }
  }
  componentDidMount = () => {
    if(typeof(drupalSettings.property_page) != "undefined") {
      var ppt_trans = drupalSettings.property_page.ppty_id;
      var property_fast_booking_id = '';
      var title = '';
      if (drupalSettings.is_sabre) {
        var properties_data = JSON.parse(drupalSettings.centara_sabre.booknow_property_data);
      }
      else {
        var properties_data = JSON.parse(drupalSettings.centara_fastbooking.booknow_property_data);
      }
      properties_data.map(function(er, i) {
        Object.keys(er).forEach(function(key) {
          if(er.ppty_id === ppt_trans) {
            property_fast_booking_id = er.field_sabre_property_id;
            title = er.title;
          }
        });
      });
      this.setState({
        ppt_name: property_fast_booking_id,
        ppt_fast: title,
        hide_flexi: false
      });
    }
  }
  render() {
    return  (
      <div className="booknow-form-wrapper">
        <div className={this.state.hide_flexi ? '': 'd-no'}>
          <Search
            setBookNowUrl = {this.setBookNowUrl}
            setFlexi = {this.setFlexi}
            isHotel = {this.state.isHotel}
          />
        </div>
        <div className="set-flexi" name={this.state.ppt_name} value={this.state.ppt_fast}></div>
        <div id="flexi-click" className={'flexi-link ' + (this.state.hide_flexi? 'd-no' : '')} onClick={drupalSettings.is_sabre === 1 ? this.setFinalUrl : undefined}>{ Drupal.t("Flexible with Your Dates?")}</div>
        <div className={'dates-input '+ (this.state.hide_flexi ? '' : 'm-bottom-margin')}>
          <label> { drupalSettings.ajaxPageState.theme === "centara_cosi" ? this.state.text_cosi : Drupal.t("Dates")  } </label>
          <div className="input-wrapper">
            <Calendar
              setCalendarData = {this.setCalendarData}
            />
          </div>
        </div>
        <div className="guest-input">
          <Guests
            setGuestData = {this.setGuestData}
          />
        </div>

        <div className="book-now-button">
          {
            drupalSettings.ajaxPageState.theme != "centara_main" ?
            <div className="best-text">
              <span className="right-icon"></span><a target="_blank" href="/best-rate-guarantee/">{ Drupal.t("Best Price Guaranteed")}{ drupalSettings.ajaxPageState.theme === "centara_cosi"? " !": " " }</a>
            </div> : ""
          }
          <div className="btn--primary" onClick = {this.setFinalUrl}> {Drupal.t("Book Now")} </div>
        </div>
      </div>
    );
  }
}

export default BookNowForm;
